import { ga } from 'js/analytics/adapters'
export const trackRequestNewPassword = () => {
  ga.track('request_new_password')
}
